import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_01.png";
import Img_Two from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_02.png";
import Img_Three from "./../../../../sources/imgs/NMAP/NMAP_03.png";
import Img_Four from "./../../../../sources/imgs/NMAP/NMAP_04.png";
import Img_Five from "./../../../../sources/imgs/NMAP/NMAP_05.png";
import Img_Six from "./../../../../sources/imgs/NMAP/NMAP_06.png";
import Img_Seven from "./../../../../sources/imgs/NMAP/NMAP_07.png";
import Img_Eight from "./../../../../sources/imgs/NMAP/NMAP_08.png";
import Img_Nine from "./../../../../sources/imgs/NMAP/NMAP_09.png";
import Img_Ten from "./../../../../sources/imgs/NMAP/NMAP_10.png";
import Img_Eleven from "../../../../sources/imgs/NMAP/NMAP_11.png";
import Img_Twelve from "../../../../sources/imgs/NMAP/NMAP_12.png";
import Img_Thirteen from "../../../../sources/imgs/NMAP/NMAP_13.png";
import Img_Fourteen from "../../../../sources/imgs/NMAP/NMAP_14.png";
import Img_Fifteen from "../../../../sources/imgs/NMAP/NMAP_15.png";
import Img_Sixteen from "../../../../sources/imgs/NMAP/NMAP_16.png";
import Img_Seventeen from "../../../../sources/imgs/NMAP/NMAP_17.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function PRIVILEGIO_02 (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> MANTENIMIENTO DE ACCESO POR ARCHIVO EN MODIFICACIÓN DE REGISTRO.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a Mantenimiento de Acceso por archivo en modificación de registro.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Una <span className="span-pink">técnica</span> <span className="span-blue">común</span> y <span className="span-blue">efectiva</span> para lograr <span className="span-pink">persistencia</span> en <span className="span-white">sistemas Windows</span> es modificar el <span className="span-white">registro del sistema</span>, específicamente la <span className="span-yellow">clave Run</span>. Esta <span className="span-yellow">clave</span> permite que se <span className="span-pink">ejecuten automáticamente programas</span> cada vez que el <span className="span-pink">usuario</span> <span className="span-white">inicia sesión</span>.
            </p>

            <p>
                Al agregar un <span className="span-pink">nuevo valor</span> a esta <span className="span-white">clave</span>, podemos hacer que un <span className="span-yellow">script malicioso</span> (por ejemplo, una <i className="span-white">reverse shell</i>) se <span className="span-pink">ejecute automáticamente</span> SIN requerir <span className="span-pink">privilegios de administrador</span>, siempre que se use el <span className="span-white">registro del usuario actual</span> <i className="span-white">(HKCU)</i>. Además, NO es necesario <span className="span-white">reiniciar el sistema</span>: el efecto es <span className="span-pink">inmediato</span> al siguiente <span className="span-white">inicio de sesión</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Ruta de Directorio de Acceso por archivo en modificación de registro.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Clave del registro de Windows</span> donde se <span className="span-pink">configura</span> la <span className="span-pink">persistencia</span> del <span className="span-white">script</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-white">Ruta completa</span>:
                    </p>
                </li>
            </ul>  

            <p>
                <i className="span-white">
                    HKEY_CURRENT_USER\Software\Microsoft\Windows\CurrentVersion\Run
                </i>
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        En <span className="span-pink">PowerShell</span>:
                    </p>
                </li>
            </ul>            
            
            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={"HKCU:\\Software\\Microsoft\Windows\\CurrentVersion\\Run"}
            />

            <p>
                Esta <span className="span-white">ubicación</span> es <span className="span-pink">específica del usuario</span> que ha <span className="span-white">iniciado sesión</span>, lo cual <span className="span-pink">evita requerir permisos de administrador</span> para <span className="span-pink">modificarla</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Creación de  modificación de registro.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                A <span className="span-white">continuación</span>, se muestran los <span className="span-pink">comandos</span> para <span className="span-pink">agregar</span> un <span className="span-white">nuevo valor en la clave Run</span> para <span className="span-pink">ejecutar</span> un <span className="span-white">script automáticamente</span>:
            </p>

            <p>
                Para <span className="span-pink">PowerShell</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`New-ItemProperty -Path "HKCU:\\Software\\Microsoft\\Windows\\CurrentVersion\\Run" `
            + `-Name "MiScript" `
            + `-Value "powershell.exe -ExecutionPolicy Bypass -WindowStyle Hidden -File C:\\ruta\\script.ps1" `
            + `-PropertyType String`}
            />

            <p>
                Para <span className="span-pink">CMD</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`reg add HKCU\\Software\Microsoft\\Windows\\CurrentVersion\\Run /v MiScript /t REG_SZ /d "powershell.exe -ExecutionPolicy Bypass -WindowStyle Hidden -File C:\\ruta\\script.ps1" /f`}
            />

            <p>
                Con estos <span className="span-pink">comandos</span>, el <span className="span-white">sistema</span> <span className="span-pink">ejecutará</span> el <span className="span-white">script especificado automáticamente</span> al <span className="span-pink">iniciar sesión</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Eliminación de modificación de registro.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para <span className="span-pink">eliminar</span> el <span className="span-white">valor agregado en la clave Run</span>:
            </p>

            <p>
                Para <span className="span-pink">PowerShell</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`Remove-ItemProperty -Path "HKCU:\\Software\\Microsoft\\Windows\\CurrentVersion\\Run" -Name "MiScript"`}
            />

            <p>
                Para <span className="span-pink">CMD</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`reg delete HKCU\\Software\\Microsoft\\Windows\\CurrentVersion\\Run /v MiScript /f`}
            />

            <p>
                Esto <span className="span-pink">elimina</span> la <span className="span-white">persistencia</span>, lo cual es <span className="span-white">recomendable</span> una vez <span className="span-pink">finalizadas</span> las <span className="span-blue">pruebas</span> o <span className="span-blue">prácticas</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Visualización de modificación de registro.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Puedes <span className="span-pink">verificar</span> si el <span className="span-white">valor</span> fue <span className="span-white">agregado correctamente</span> con los <span className="span-pink">siguientes comandos</span>:
            </p>

            <p>
                Para <span className="span-pink">PowerShell</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`Get-ItemProperty -Path "HKCU:\\Software\\Microsoft\\Windows\\CurrentVersion\\Run"`}
            />

            <p>
                Para <span className="span-pink">CMD</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`reg query HKCU\\Software\\Microsoft\\Windows\\CurrentVersion\\Run`}
            />

            <p>
                Estos <span className="span-pink">comandos</span> <span className="span-white">listan</span> <span className="span-pink">TODOS los programas configurados</span>  para <span className="span-white">ejecutarse al inicio de sesión</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Conclusiones.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-pink">Modificar</span> la <span className="span-white">clave Run del registro del usuario</span> es una <span className="span-blue">técnica simple</span>, <span className="span-blue">rápida</span> y <span className="span-blue">silenciosa</span> para <span className="span-pink">lograr persistencia en sistemas Windows</span>. <span className="span-white">Sin embargo</span>, su uso debe estar <span className="span-pink">limitado</span> a <span className="span-blue">entornos controlados</span>, como <span className="span-blue">laboratorios</span>, <span className="span-blue">simulaciones</span> o <span className="span-blue">pruebas autorizadas</span>. Debe ser <span className="span-pink">utilizada</span> con <span className="span-blue">responsabilidad</span> y siempre con <span className="span-blue">autorización explícita</span>.
            </p>

            <p>
               <span className="span-yellow">Nota:</span> Este <span className="span-pink">método</span> <span className="span-white">NO</span> debe ser empleado en <span className="span-pink">entornos reales</span> SIN el <span className="span-pink">consentimiento expreso</span> del <span className="span-white">propietario del sistema</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Recomendaciones.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para <span className="span-white">propósitos</span> de <span className="span-yellow">hacking ético</span> o <span className="span-blue">pruebas de laboratorio</span>, puedes:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Insertar</span> tu <span className="span-white">propia entrada</span> con un <span className="span-pink">nombre</span> que <span className="span-white">NO genere sospechas</span> (ej. <i className="span-white">Windows Update</i> o <i className="span-white">SecurityCheck</i>).
                    </p>
                </li>

                <li>
                    <p>
                        Luego <span className="span-pink">consultar</span> con <i className="span-white">reg query</i> para <span className="span-pink">confirmar</span> que fue <span className="span-blue">agregada correctamente</span>.
                    </p>
                </li>

                <li>
                    <p>
                        Para <span className="span-white">mayor sigilo</span>, <span className="span-pink">almacena</span> tu <span className="span-white">script</span> en <span className="span-white">rutas no visibles fácilmente</span> o <span className="span-white">utiliza técnicas de ofuscación</span>.
                    </p>
                </li>

                <li>
                    <p>
                        Y <span className="span-pink">eliminarla</span> cuando <span className="span-pink">termines</span> tu <span className="span-white">sesión</span> o <span className="span-white">prueba</span>.
                    </p>
                </li>
            </ul>
        </>
    );
}